'use client'
import { type FC, type ReactNode } from 'react'
import dynamic from 'next/dynamic'
import StyledComponentsRegistry from '@/utils/styledComponentsRegistry'
import { designGrid, Susy } from '@/styles'
import { PRO } from '@/utils'
import { ModalsProvider } from '@/context'
import { TranslationsProvider } from '@/context'
import type { TypeLang } from '@/utils'
import { Navbar } from './layout/Navbar'
import styled from 'styled-components'

type Props = {
  children: ReactNode
  lang?: TypeLang
}

const DynamicModalMenu = dynamic(() => import('./modals/ModalMobileMenu/ModalMenu').then(mod => mod.ModalMenu), { ssr: false })

const ClientProviders: FC<Props> = ({ children }) => {
  return (
    <StyledComponentsRegistry>
      <TranslationsProvider>
        <ModalsProvider>
            <Div>
              <Navbar />
              {children}
            </Div>
            <DynamicModalMenu />
        </ModalsProvider>
      </TranslationsProvider>
      {!PRO && <Susy />}
    </StyledComponentsRegistry>
  )
}

export default ClientProviders

const Div = styled.div`
  ${designGrid({ withoutGutter: true })}
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`
